<template>
  <div>
    <slot name="train-milestones" />
    <div class="train">
      <slot name="header"/>
      <slot name="train"/>
    </div>
  </div>
</template>
<script>
  export default {
    // updated() {
    //   console.log('train updated');
    // }
  }
</script>
<style scoped>
  .train {
    display: inline-block;
    flex-direction: row;
    /* padding-top: 5px;
    padding-bottom: 5px; */
    transform: translateZ(0);
    will-change: height;
    overflow: visible;
  }
</style>
